import React from 'react';


export const D3JS = props => {
    return (
        <img className={props.className} src={require('../../../resources/images/png_icons/d3js.png')} />
    )
};
